import LazyImage from './lazyImage'

export default LazyImage
